/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".root_4da6b750{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:baseline;-ms-flex-align:baseline;align-items:baseline}.root_4da6b750 .dropdown_4da6b750{margin-bottom:0;margin-left:5px}\n"}]);
export const root = "root_4da6b750";
export const dropdown = "dropdown_4da6b750";